import {hasAnalyticsConsent,loadLocalConsent} from './consent';
import config from '../../../config/bite-ga4.json';

// Bite's default analytics policy is not an affirmative consent record.
// Existing refusals and the separately opt-in account SDK remain unchanged.
export function allowsBiteGa4() {
  const choice=loadLocalConsent();
  return choice?.ts ? hasAnalyticsConsent() : Boolean(config.defaultAnalyticsPolicy);
}
export function biteGa4PolicyContext() {
  return !loadLocalConsent()?.ts ? {ga4Policy:config.defaultAnalyticsPolicy} : {};
}
